import * as types from "../actions/actiontype";
import * as appUtilityFunction from '../../../infrastructure/apputilityfunctions'

const initialState = {

}

export default function policyReducer(state = initialState, action) {
    switch (action.type) {
        
        
        default:
            return state;
    }
}